const columns = [
  {
    title: "内容分区",
    links: ["今日更新", "话题墙", "深度长文", "时间线档案"],
  },
  {
    title: "会员服务",
    links: ["会员特权", "提前看料", "完整版专区", "付费资源"],
  },
  {
    title: "关于本站",
    links: ["专题说明", "内容规范", "常见问题", "联系我们"],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-secondary-950">
                <i className="ri-vip-diamond-fill text-xl" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">黑料福利</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              以专题合集的方式整理公开可查的信息线索，黑料福利会员可解锁专属与内部内容，
              提前看料、看完整版，把高价值内容一网打尽。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["专题合集", "话题墙", "会员特权"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-secondary-900 px-3 py-1 text-xs text-background-200"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-base font-semibold text-background-50">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="text-sm text-background-300 transition-colors hover:text-accent-400"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © 2026 黑料福利 · 本站为专题合集浏览站，内容以公开信息整理为主
          </p>
          <p className="text-xs text-background-400">浏览体验建议使用最新版浏览器</p>
        </div>
      </div>
    </footer>
  );
}